export function createMerchantLocationClient(transport) {
    return {
        /**
         * GET /health/live
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getLiveness(options) {
            return transport.request({
                method: "GET",
                path: "/health/live",
                options,
            });
        },
        /**
         * GET /health/ready
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getReadiness(options) {
            return transport.request({
                method: "GET",
                path: "/health/ready",
                options,
            });
        },
        /**
         * POST /v1/merchant-locations
         *
         * Requires scope: merchant-location:create
         */
        createMerchantLocation(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/merchant-locations",
                body,
                options,
            });
        },
        /**
         * GET /v1/merchant-locations/{locationId}
         *
         * Requires scope: merchant-location:read
         */
        getMerchantLocation(locationId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/merchant-locations/${encodeURIComponent(locationId)}`,
                options,
            });
        },
        /**
         * PATCH /v1/merchant-locations/{locationId}
         *
         * Requires scope: merchant-location:update
         */
        updateMerchantLocation(locationId, body, options) {
            return transport.request({
                method: "PATCH",
                path: `/v1/merchant-locations/${encodeURIComponent(locationId)}`,
                body,
                options,
            });
        },
        /**
         * POST /v1/merchant-locations/{locationId}/status
         *
         * Requires scope: merchant-location:lifecycle
         */
        changeMerchantLocationStatus(locationId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/merchant-locations/${encodeURIComponent(locationId)}/status`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
        /**
         * One page of a merchant's branches, by branch code
         *
         * Requires scope: merchant-location:read
         */
        listMerchantLocations(merchantId, limit, after, status, options) {
            return transport.request({
                method: "GET",
                path: `/v1/merchants/${encodeURIComponent(merchantId)}/locations`,
                query: { limit: limit, after: after, status: status },
                options,
            });
        },
    };
}
//# sourceMappingURL=merchant-location.js.map